import langCN from './zh-cn'
export default langCN
// import langTW from './zh-tw'
// 设置语言
// const lang = (navigator.language || navigator.browserLanguage).toLowerCase()

// const $language = lang === 'zh-cn' ? langCN : langTW

// export default $language
